import { Component } from "@angular/core";

@Component({
    selector: 'public-footer-component',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    mailmsg:string;

    SendMail(data)
    {
        if(this.mailmsg != null)
        {
            var mail = document.createElement("a");
            mail.href = "mailto:contact@enl.solutions?body=" + this.mailmsg + '';
            mail.click();
            this.mailmsg = null;
        } 
    }    

    currentYear = new Date().getFullYear();
}